import * as React from "react";
const SvgFiRrSkateboard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-skateboard_svg__a)">
      <path
        fill="#062147"
        d="M21.835 2.165a7.39 7.39 0 0 0-10.451 0l-9.219 9.219a7.39 7.39 0 1 0 10.451 10.45l9.219-9.218a7.39 7.39 0 0 0 0-10.451M20.421 11.2 11.2 20.42a5.39 5.39 0 1 1-7.621-7.62L12.8 3.579a5.39 5.39 0 1 1 7.621 7.62m-.714-2.91a1 1 0 0 1 0 1.415l-3 3a1 1 0 0 1-1.414-1.414l.793-.793L13.5 7.914l-.793.793a1 1 0 0 1-1.414-1.414l3-3a1 1 0 1 1 1.414 1.414l-.793.793L17.5 9.086l.793-.793a1 1 0 0 1 1.414 0zm-7 7a1 1 0 0 1 0 1.415l-3 3a1 1 0 0 1-1.414-1.414l.793-.793L6.5 14.914l-.793.793a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 1.414l-.793.793 2.586 2.586.793-.793a1 1 0 0 1 1.414 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-skateboard_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkateboard;
